import {Component, Input} from '@angular/core';
import {Product} from '../../classes/product';
import {CustomDatePipe} from '../../pipes/custom.date.pipe';

@Component({
	selector: 'product-more-available',
	templateUrl: 'product.more.available.component.html',
	styleUrls: ['./product.more.available.component.scss'],
	standalone: true,
	imports: [CustomDatePipe],
})
export class ProductMoreAvailableComponent {
	@Input() product: Product;

	getAvailableLaterDate(): Date | null {
		if (!this.product.availableLaterDate) {
			return null;
		}

		return new Date(this.product.availableLaterDate);
	}
}
